import React, { useState } from 'react';
import Styles from './SeguroAuto25Cotacao.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';
function SeguroAuto25Cotacao() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguro-auto-cotacao">
        <ContainerHome24>
          <div className="cotacao-contain">
            <div className="cotacao-textos">
              <h2 className="cotacao-titulo">Faça uma cotação de Seguro Auto com o Santander</h2>
              <p className="cotacao-texto">
                Ao contratar o Seguro Auto, você tem acesso a diversos serviços exclusivos. Fale com
                a Ecoagile, nossa correspondente oficial, para saber mais.
              </p>
            </div>
            <div className="cotacao-servicos">
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-guincho.svg" alt="" />
                <p className="cotacao-servico-texto">Guincho</p>
              </div>
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-socorro-auto.svg" alt="" />
                <p className="cotacao-servico-texto">Socorro auto</p>
              </div>
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-taxi.svg" alt="" />
                <p className="cotacao-servico-texto">Táxi</p>
              </div>
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-troca-pneu.svg" alt="" />
                <p className="cotacao-servico-texto">
                  Troca <br />
                  de pneu
                </p>
              </div>
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-chaveiro.svg" alt="" />
                <p className="cotacao-servico-texto">Chaveiro</p>
              </div>
              <div className="cotacao-servico">
                <img src="assets/seguro-auto-25/cotacao/ic-pane-seca.svg" alt="" />
                <p className="cotacao-servico-texto">Pane seca</p>
              </div>
            </div>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width >= 992 && (
                  <img
                    src="assets/seguro-auto-25/cotacao/img-cotacao-carros-desk.png"
                    alt=""
                    className="img-carros"
                  />
                )}
              </>
            )}
          </div>
          <WhiteButton
            href="https://api.whatsapp.com/send?phone=5517991332650&text=Ol%C3%A1,%20vim%20atrav%C3%A9s%20do%20site%20da%20Santander%20Financiamentos%20e%20gostaria%20de%20fazer%20uma%20cota%C3%A7%C3%A3o%20de%20seguro%20auto"
            target="_blank"
            className="btn-cotacao"
          >
            Fazer cotação
          </WhiteButton>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && <p className="cotacao-disclaimer">*Conforme o plano contratado.</p>}
            </>
          )}
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width < 992 && (
              <>
                <img
                  src="assets/seguro-auto-25/cotacao/img-cotacao-carros.png"
                  alt=""
                  className="img-carros"
                />
                <ContainerHome24>
                  <p className="cotacao-disclaimer">*Conforme o plano contratado.</p>
                </ContainerHome24>
              </>
            )}
          </>
        )}
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25Cotacao;
